import script from "./CardGestionTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardGestionTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./CardGestionTorneo.vue?vue&type=style&index=0&id=63d16ec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d16ec4"]])

export default __exports__